export default "__VITE_ASSET__DBvFDiww__"